// GeoSampa WMS layer configuration and MapLibre helpers
// Tiles and legends are proxied through Rails to avoid CORS issues

const HOST_WMS = 'wms'
const HOST_RASTER = 'raster'

export const GEOSAMPA_CATEGORIES = [
  {
    id: 'mapa-base',
    label: 'Mapa Base + Ortofoto',
    layers: [
      { id: 'gs-orto-mosaico', label: 'Mosaico Ortofoto 10/20cm', layerName: 'MOSAICO_ORTO_RGB_10CM_20CM', host: HOST_RASTER },
      { id: 'gs-orto-2020', label: 'Ortofoto 2020', layerName: 'ORTO_RGB_2020', host: HOST_RASTER },
      { id: 'gs-base-politico', label: 'Mapa Base Pol\u00edtico', layerName: 'MapaBase_Politico', host: HOST_WMS },
      { id: 'gs-base-topografico', label: 'Mapa Base Topogr\u00e1fico', layerName: 'MapaBase_Topografico', host: HOST_WMS },
      { id: 'gs-edificacao', label: 'Edifica\u00e7\u00f5es', layerName: 'geoportal:edificacao', host: HOST_WMS },
      { id: 'gs-logradouro', label: 'Logradouros', layerName: 'geoportal:segmento_logradouro', host: HOST_WMS },
    ],
  },
  {
    id: 'limites-admin',
    label: 'Limites Administrativos',
    layers: [
      { id: 'gs-distrito', label: 'Distritos', layerName: 'geoportal:distrito_municipal', host: HOST_WMS },
      { id: 'gs-subprefeitura', label: 'Subprefeituras', layerName: 'geoportal:subprefeitura', host: HOST_WMS },
      { id: 'gs-setor-fiscal', label: 'Setores Fiscais', layerName: 'geoportal:setor_fiscal', host: HOST_WMS },
      { id: 'gs-quadra-fiscal', label: 'Quadras Fiscais', layerName: 'geoportal:quadra_fiscal', host: HOST_WMS },
      { id: 'gs-lote-cidadao', label: 'Lotes', layerName: 'geoportal:lote_cidadao', host: HOST_WMS },
      { id: 'gs-setor-censitario', label: 'Setores Censit\u00e1rios 2022', layerName: 'geoportal:setor_censitario_2022', host: HOST_WMS },
    ],
  },
  {
    id: 'populacao',
    label: 'Popula\u00e7\u00e3o',
    layers: [
      { id: 'gs-densidade', label: 'Densidade Demogr\u00e1fica', layerName: 'geoportal:densidade_demografica', host: HOST_WMS },
      { id: 'gs-censo-pop', label: 'Setores Censit\u00e1rios', layerName: 'geoportal:setor_censitario_2022', host: HOST_WMS },
      { id: 'gs-ipvs', label: '\u00cdndice de Vulnerabilidade Social (IPVS)', layerName: 'geoportal:indice_paulista_vulnerabilidadesocial', host: HOST_WMS },
    ],
  },
  {
    id: 'transporte',
    label: 'Transporte',
    layers: [
      { id: 'gs-linha-metro', label: 'Linhas de Metr\u00f4', layerName: 'geoportal:linha_metro', host: HOST_WMS },
      { id: 'gs-estacao-metro', label: 'Esta\u00e7\u00f5es de Metr\u00f4', layerName: 'geoportal:estacao_metro', host: HOST_WMS },
      { id: 'gs-linha-trem', label: 'Linhas de Trem', layerName: 'geoportal:linha_trem', host: HOST_WMS },
      { id: 'gs-estacao-trem', label: 'Esta\u00e7\u00f5es de Trem', layerName: 'geoportal:estacao_trem', host: HOST_WMS },
      { id: 'gs-linha-onibus', label: 'Linhas de \u00d4nibus', layerName: 'geoportal:linha_onibus', host: HOST_WMS },
      { id: 'gs-ponto-onibus', label: 'Pontos de \u00d4nibus', layerName: 'geoportal:ponto_onibus', host: HOST_WMS },
      { id: 'gs-corredor-onibus', label: 'Corredores de \u00d4nibus', layerName: 'geoportal:corredor_onibus', host: HOST_WMS },
      { id: 'gs-terminal-onibus', label: 'Terminais de \u00d4nibus', layerName: 'geoportal:terminal_onibus', host: HOST_WMS },
      { id: 'gs-ciclovia', label: 'Ciclovias', layerName: 'geoportal:via_bicicleta', host: HOST_WMS },
      { id: 'gs-class-viaria', label: 'Classifica\u00e7\u00e3o Vi\u00e1ria', layerName: 'geoportal:classificacao_viaria_cet', host: HOST_WMS },
    ],
  },
  {
    id: 'verde',
    label: 'Verde',
    layers: [
      { id: 'gs-parques', label: 'Parques e Unidades de Conserva\u00e7\u00e3o', layerName: 'geoportal:GEOSAMPA_cadparcs_parque_unidade_conservacao', host: HOST_WMS },
      { id: 'gs-cobertura-vegetal', label: 'Cobertura Vegetal', layerName: 'geoportal:cobertura_vegetal', host: HOST_WMS },
      { id: 'gs-arborizacao', label: 'Arboriza\u00e7\u00e3o Vi\u00e1ria', layerName: 'geoportal:arvore', host: HOST_WMS },
      { id: 'gs-pracas', label: 'Pra\u00e7as e Largos', layerName: 'geoportal:GEOSAMPA_v_praca_largo', host: HOST_WMS },
      { id: 'gs-mata-atlantica', label: 'Remanescentes Mata Atl\u00e2ntica', layerName: 'geoportal:remanescente_pmma', host: HOST_WMS },
    ],
  },
  {
    id: 'uso-solo',
    label: 'Uso do Solo',
    layers: [
      { id: 'gs-uso-2021-simples', label: 'Uso Predominante 2021 (Simples)', layerName: 'geoportal:uso_predominante_solo_2021_simples', host: HOST_WMS },
      { id: 'gs-uso-2021-60', label: 'Uso Predominante 2021 (\u226560%)', layerName: 'geoportal:uso_predominante_solo_2021_60', host: HOST_WMS },
    ],
  },
  {
    id: 'legislacao',
    label: 'Legisla\u00e7\u00e3o',
    layers: [
      { id: 'gs-zoneamento', label: 'Zoneamento (Lei 18.177/24)', layerName: 'geoportal:perimetro_zona_lei_18177_24', host: HOST_WMS },
      { id: 'gs-macroareas', label: 'Macro\u00e1reas (Lei 18.209/24)', layerName: 'geoportal:pde_macroarea_lei_18209', host: HOST_WMS },
      { id: 'gs-eixos', label: 'Eixos de Estrutura\u00e7\u00e3o', layerName: 'geoportal:pde2014_v_eetr_03_map', host: HOST_WMS },
      { id: 'gs-zeis1', label: 'ZEIS 1', layerName: 'geoportal:pde2014_v_zeis_04_map', host: HOST_WMS },
      { id: 'gs-zeis2345', label: 'ZEIS 2, 3, 4, 5', layerName: 'geoportal:pde2014_v_zeis_04a_map', host: HOST_WMS },
      { id: 'gs-operacao-urbana', label: 'Opera\u00e7\u00f5es Urbanas', layerName: 'geoportal:operacao_urbana', host: HOST_WMS },
      { id: 'gs-outorga', label: 'Outorga Onerosa', layerName: 'geoportal:outorga_onerosa', host: HOST_WMS },
    ],
  },
]

export function buildTileUrl(layer) {
  return `/geosampa/wms_tile?host=${layer.host}&layers=${encodeURIComponent(layer.layerName)}&width=256&height=256&bbox={bbox-epsg-3857}`
}

export function buildLegendUrl(layer) {
  return `/geosampa/wms_legend?host=${layer.host}&layer=${encodeURIComponent(layer.layerName)}`
}

export function findLayerById(layerId) {
  for (const cat of GEOSAMPA_CATEGORIES) {
    const found = cat.layers.find(l => l.id === layerId)
    if (found) return found
  }
  return null
}

// First app layer ID — GeoSampa layers insert before this
const APP_LAYERS = ['varejos-layer', 'polos-fill', 'polos-outline', 'lotes-fill', 'lotes-outline']

function findFirstAppLayer(map) {
  for (const id of APP_LAYERS) {
    if (map.getLayer(id)) return id
  }
  return undefined
}

export function addGeosampaLayer(map, layerId) {
  const config = findLayerById(layerId)
  if (!config || map.getSource(layerId)) return

  map.addSource(layerId, {
    type: 'raster',
    tiles: [buildTileUrl(config)],
    tileSize: 256,
  })

  map.addLayer(
    {
      id: layerId,
      type: 'raster',
      source: layerId,
      paint: { 'raster-opacity': 0.7 },
    },
    findFirstAppLayer(map)
  )
}

export function removeGeosampaLayer(map, layerId) {
  if (map.getLayer(layerId)) map.removeLayer(layerId)
  if (map.getSource(layerId)) map.removeSource(layerId)
}
